import { PropsWithChildren } from 'react';
import Submit from '~/components/button/Submit';
import CustomerInfoDisplay from '~/components/CustomerInfoDisplay';
import Divide from '~/components/Divide';
import Form from '~/components/Form';
import Page from '~/components/layout/page/Page';
import LineItem from '~/components/LineItem';
import LoadingBoundary from '~/components/LoadingBoundary';
import MediaDisplay from '~/components/MediaDisplay';
import { useUniqueId } from '~/utils/compute';
import { useLoaderData } from './shippingClaimReview';

function ReviewSection({
  title,
  children,
}: PropsWithChildren<{ title: string }>) {
  const id = useUniqueId();

  return (
    <section aria-labelledby={id}>
      <h3 id={id} className="mb-2 label-lg">
        {title}
      </h3>
      {children}
    </section>
  );
}

export default function ShippingClaimReviewPage() {
  const data = useLoaderData();

  return (
    <Page.Root title="Request">
      <LoadingBoundary>
        <Divide spacing="loose">
          <ReviewSection title="Reason">
            <p>{data.reason}</p>
          </ReviewSection>

          {data.meta.noteFromCustomer && (
            <ReviewSection title="Comments">
              <p>{data.meta.noteFromCustomer}</p>
            </ReviewSection>
          )}

          {data.meta.assets && data.meta.assets.length > 0 && (
            <ReviewSection title="Attachments">
              <div className="grid grid-cols-2 gap-4 pt-1 md:grid-cols-3">
                {data.meta.assets.map(({ src, name, type }) => (
                  <MediaDisplay
                    expandable
                    key={name}
                    alt={name}
                    src={src}
                    type={type}
                  />
                ))}
              </div>
            </ReviewSection>
          )}

          <ReviewSection title="Items">
            {data.items.map((item) => (
              <LineItem
                className="py-2 last:pb-0"
                key={item.id}
                variant="small"
                name={item.name ?? 'N/A'}
                imgSrc={item.imgUrl}
                quantity={item.quantity}
                price={item.unitPrice}
                options={item.optionsFromPlatform}
              />
            ))}
          </ReviewSection>

          <ReviewSection title="Address">
            <CustomerInfoDisplay
              info={{
                firstName: data.customerInfo.firstName,
                lastName: data.customerInfo.lastName,
                address: data.customerInfo.address,
              }}
            />
          </ReviewSection>
        </Divide>
        <Form>
          <input type="hidden" hidden name="claim" value="create" />
          <Submit>Submit Request</Submit>
        </Form>
      </LoadingBoundary>
    </Page.Root>
  );
}
